import React, { Fragment } from "react";
import styled from "styled-components";
import { IC } from "../../../resources/Assets";

export default (props) => {
  const onClickEvent = (e, data) => {
    props.setTargetList("DELETE", data, e);
  };
  return (
    <Fragment>
      <div className="data01">
        <label className="check-box">
          <input
            type="checkbox"
            name="checkSeqNo"
            id={props.dataInfo.seqNo}
            onChange={(e) =>
              onClickEvent(e.target.checked, props.dataInfo.seqNo)
            }
          />
          <i />
          <span>{props.dataInfo.date1 + "(" + props.dataInfo.date2 + ")"}</span>
        </label>
      </div>

      <div style={{ position: "relative" }}>
        <div>
          {/* <FaceIcon faceType={props.dataInfo.studCndtn === 'HIGH' ? 'GLOOM' : 'SMILE'} /> */}
        </div>
        {/* <ListData color={props.dataInfo.studCndtn === 'HIGH' ? '#E3C4CE' : '#2FCEAF'}> */}
        <ListData color={"#2FCEAF"}>{props.dataInfo.studRslt + "%"}</ListData>
      </div>
    </Fragment>
  );
};

const FaceIcon = styled.i`
  background-image: url(${(props) =>
    props.faceType === "SMILE"
      ? IC.faceIcon.GREENSMILE
      : IC.faceIcon.GREENGLOOM});
  position: absolute;
  top: 16px;
  left: 15px;
  width: 32px;
  height: 32px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`;

// padding:20px 50px 0 65px;
const ListData = styled.div`
    padding: 20px 50px 0 21px;
    color: ${(props) => (props.color ? props.color : "#fff")};
    font-size: 20px;
`;